// extracted by mini-css-extract-plugin
export default {"titleContainer":"PatientAssistentialStaff_titleContainer__k9OPN","userList":"PatientAssistentialStaff_userList__-Qytl"};